export default theme => ({
  textField: { minWidth: 20 * theme.spacing.unit, marginTop: '6px' },
  helperTextAndTextFieldContainer: {
    height: '100%',
  },
})
